import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Content from "../utilities/content";
import CmsLink from "../utilities/cms-link";
import CmsImage from "../utilities/cms-image";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, EffectCreative } from "swiper/modules";

const FooterCTA = ({ hideFooterCta }) => {
  const {
    wp: {
      themeSettings: { themeSettings: data },
    },
    allWpPost: recentNews,
  } = useStaticQuery(graphql`query FooterCTA {
  wp {
    themeSettings {
      themeSettings {
        ctaNewsContent
        ctaContent
        ctaLink {
          target
          title
          url
        }
      }
    }
  }
  allWpPost(
    filter: {categories: {nodes: {elemMatch: {name: {eq: "Recent News"}}}}}
    sort: {date: DESC}
    limit: 10
  ) {
    nodes {
      id
      uri
      title
      date(fromNow: true, formatString: "MMM DD YYYY")
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 760, height: 427)
            }
            extension
            publicURL
          }
        }
      }
    }
  }
}`);

  let swiperAttributes = {
    className: "swiper-news mt-4",
    loop: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: false,
        translate: [-40, 0, 0],
        scale: 0.75,
        origin: "left center",
      },
      next: {
        shadow: false,
        translate: [40, 0, 0],
        scale: 0.75,
        origin: "right center",
      },
    },
    centeredSlides: true,
    slidesPerView: 1,
    loopAdditionalSlides: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    modules: [Navigation, EffectCreative],
  };
  let posts = recentNews.nodes;

  if (hideFooterCta) return null;

  return (
    <section className="section footer-cta">
      <div className="container">
        <div className="row align-items-top">
          <div className="col-lg-6 mb-5 mb-lg-0 left-wrapper">
            <div className="pe-lg-5">
              <Content className="content-title-bg-image">
                {data.ctaNewsContent}
              </Content>
              <Swiper {...swiperAttributes}>
                {posts &&
                  posts.map((post, key) => (
                    <SwiperSlide key={key}>
                      {post.featuredImage && (
                        <div>
                          <a href={post.uri}>
                            <h4>{post.title}</h4>
                            <CmsImage
                              className="img-fluid mx-auto d-flex w-70"
                              image={post.featuredImage.node}
                            />
                          </a>
                        </div>
                      )}
                    </SwiperSlide>
                  ))}
                <div className="swiper-button-prev" />
                <div className="swiper-button-next" />
              </Swiper>
            </div>
          </div>

          <div className="col-lg-6 right-wrapper">
            <div className="ps-lg-5">
              <Content className="content-title-bg-image">
                {data.ctaContent}
              </Content>
              <div className="mt-5">
                {data.ctaLink && (
                  <CmsLink
                    className="btn btn-primary  me-n4 btn-arrow"
                    link={data.ctaLink}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterCTA;
